import * as HelmetAsync from "react-helmet-async";

type HelmetModule = typeof HelmetAsync & {
  default?: Partial<typeof HelmetAsync>;
};

const moduleRef = HelmetAsync as HelmetModule;

export const HelmetProvider =
  moduleRef.HelmetProvider ?? moduleRef.default?.HelmetProvider;

export const Helmet = moduleRef.Helmet ?? moduleRef.default?.Helmet;
